import Grid from '@mui/material/Grid';
import { Button } from '@openx/components-core/lib/Button/Button';
import type { AppInventoryVersionType } from '@openx/types/targeting/appInventory';
import { type AppBundleIdOptionPayload, InventoryContentOption } from '@openx/types/targeting/inventoryAndContent';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DrawerTopBox } from '../../TargetingDrawer/DrawerTopBox';
import { AppBundleIdWithInventoryList } from './AppBundleIdWithInventoryList';
import type { TopBoxRendererProps } from './TopBoxRenderer';

type OaAppBundleIdTopBoxRendererProps = Omit<
  TopBoxRendererProps,
  | 'isBefInstance'
  | 'inputInstanceValue'
  | 'contentOption'
  | 'setInputInstanceValue'
  | 'dispatchInstance'
  | 'targetingParams'
  | 'appInventoryType'
  | 'setAppInventoryType'
  | 'drawerContentBase'
> & {
  inventoryContent: AppBundleIdOptionPayload;
  inventoryVersion?: AppInventoryVersionType;
};

export const OaAppBundleIdTopBoxRenderer = ({
  comparisonType,
  inventoryContent,
  parentAccountFeatures,
  accountUid,
  showBulkAdd,
  isLimitReached,
  setComparisonType,
  setContentOption,
  setAppBundleIdDuplicateErrors,
  onBulkOpen,
  dispatchInventory,
  inventoryVersion,
}: OaAppBundleIdTopBoxRendererProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      setAppBundleIdDuplicateErrors(null);
    };
  }, [setAppBundleIdDuplicateErrors]);

  return (
    <DrawerTopBox>
      <Grid
        container
        spacing={1}
        sx={{
          alignItems: 'flex-start',
          flexGrow: 1,
        }}
      >
        <Grid size={12}>
          <AppBundleIdWithInventoryList
            contentOption={InventoryContentOption.APP_BUNDLE_ID}
            comparisonType={comparisonType}
            inventoryContent={inventoryContent}
            parentAccountFeatures={parentAccountFeatures}
            accountUid={accountUid}
            dispatchInventory={dispatchInventory}
            setComparisonType={setComparisonType}
            setContentOption={setContentOption}
            setAppBundleIdDuplicateErrors={setAppBundleIdDuplicateErrors}
            inventoryVersion={inventoryVersion}
          />
        </Grid>

        {showBulkAdd && (
          <Grid size={12}>
            <Button disabled={isLimitReached} onClick={onBulkOpen}>
              {t('Bulk Add')}
            </Button>
          </Grid>
        )}
      </Grid>
    </DrawerTopBox>
  );
};
